import { useEffect, useState } from 'react';

// Selected FY is shared via a tiny module-level store so the toolbar (outside
// page-body) and the reports body stay in sync without lifting more state.
let selectedFY: string | null = null;
const fyListeners = new Set<() => void>();
export function setSelectedFY(fy: string) {
  selectedFY = fy;
  fyListeners.forEach((fn) => fn());
}
export function useSelectedFY(defaultFY: string): string {
  const [, force] = useState(0);
  useEffect(() => {
    const fn = () => force((n) => n + 1);
    fyListeners.add(fn);
    return () => {
      fyListeners.delete(fn);
    };
  }, []);
  return selectedFY ?? defaultFY;
}
